import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function ADRGods() {
  return (
    <>
      <SEO
        title="Farligt Gods | Fastlane ApS"
        description="Vi har stor viden om håndtering, mærkning, pakning og forsendelse af farligt gods på vej, bane, sø og fly. Software til udskrivning af ADR og IMDG dokumenter."
        canonicalUrl="https://fastlane.dk/adr-gods"
      />

      <PageHeader
        title="Farligt Gods (ADR)"
        subtitle="Specialiseret viden og godkendte procedurer for transport af farligt gods på vej, bane, sø og fly."
        breadcrumbs={[
          { label: 'Ydelser', path: '/godstransport-i-europa' },
          { label: 'Farligt Gods' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <h2 className="text-2xl font-bold text-[#0f2b48]">Specialist i Farligt Gods</h2>
            <p>
              Transport af farligt gods er en af de nicher vi har akkummuleret stor viden om i virksomheden. Vi er i stand til at vejlede vore kunder og afklare tvivlsspørgsmål i forbindelse med forsendelse, pakning og mærkning.
            </p>
            <p>
              Fastlane ApS abonnere desuden på software til udskrivning af ADR og IMDG dokumenter.
            </p>
            <p>
              Dokumenter laves gerne på vegne af vores kunder/afsender. Kunden/afsender giver input til os, hvorefter det er afsender, der kvittere med signatur for at godset som sendes, emballagen og mærkningen er i overensstemmelse med de udarbejdede dokumenter.
            </p>
          </div>

          {/* Download Box */}
          <div className="p-6 bg-slate-50 rounded-2xl border border-slate-200/90 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <i className="fa-solid fa-file-pdf text-red-600 text-3xl shrink-0" aria-hidden="true" />
              <div>
                <h4 className="font-bold text-slate-900 text-base">Instruktion: Farligt Gods</h4>
                <p className="text-xs text-slate-600">Generel vejledende instruktion i PDF-format</p>
              </div>
            </div>
            <a
              href="https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-4-rev-01-instruktion-farligtgods.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#0f2b48] hover:bg-sky-900 text-white text-xs font-semibold rounded-lg transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-download" aria-hidden="true" />
              <span>Hent PDF (277 KB)</span>
            </a>
          </div>

          {/* Contact Box */}
          <div className="p-6 rounded-2xl bg-amber-50 border border-amber-200">
            <h4 className="font-bold text-amber-950 text-base mb-1">Har du spørgsmål til en farligt gods-forsendelse?</h4>
            <p className="text-sm text-amber-900 mb-4">
              Ring til os på <a href="tel:+4576121230" className="font-bold underline whitespace-nowrap">+45 76 12 12 30</a> eller send en forespørgsel, så rådgiver vi dig om regler, mærkning og de rette transportører.
            </p>
            <Link
              to="/fragtrater"
              className="inline-flex items-center px-4 py-2 rounded-lg bg-[#b25d19] text-white text-xs font-semibold hover:bg-[#974d12]"
            >
              Forespørgsel på ADR transport
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
